import * as React from 'react';
import { ComponentExt } from '@utils/reactExt';
import { TabBar } from 'antd-mobile';
import Home from '@viewsE/home';
import Shop from '@viewsE/shop';
import CustomerService from '@viewsE/customerService';

export default class Main extends ComponentExt {
    state = { selectedTab: 'home' };

    render() {
        return (
            <div style={{ position: 'fixed', height: '100%', width: '100%', top: 0 }}>
                <TabBar
                    unselectedTintColor="#949494"
                    tintColor="#EB6A1A"
                    barTintColor="white"
                >
                    <TabBar.Item
                        title="Home"
                        key="home"
                        selected={this.state.selectedTab === 'home'}
                        onPress={() => this.setState({ selectedTab: 'home' })}
                    >
                        {this.state.selectedTab === 'home' && <Home />}
                    </TabBar.Item>
                    <TabBar.Item
                        title="Shop"
                        key="shop"
                        selected={this.state.selectedTab === 'shop'}
                        onPress={() => this.setState({ selectedTab: 'shop' })}
                    >
                        {this.state.selectedTab === 'shop' && <Shop />}
                    </TabBar.Item>
                    <TabBar.Item
                        title="Customer Service"
                        key="cs"
                        selected={this.state.selectedTab === 'cs'}
                        onPress={() => this.setState({ selectedTab: 'cs' })}
                    >
                        {this.state.selectedTab === 'cs' && <CustomerService />}
                    </TabBar.Item>
                </TabBar>
            </div>
        );
    }
}
